// import { v4 as uuid } from 'uuid';
import notifications from './notifications';

import { AddNotification, AddToastNotification } from '@/constants/mutations';
// import { notifications } from '@/constants/notifications';

// const DEFAULT_TOAST_CONFIG = {
//   type: 'info',
//   duration: '4000',
//   closable: false,
//   opened: false,
// };

export class NotificationService {
  constructor(ctx, provides) {
    const { $store } = ctx;
    this.ctx = ctx;
    this.store = $store;
    const { notificationsTypes } = notifications(ctx, provides);
    this.notifications = notificationsTypes;
  }

  /**
   * Show a toast notification.
   */
  addToast(event) {
    if (event.notificationType.includes('DOCUMENT_TRANSLATION_')) {
      const status = /[^_]*$/.exec(event.notificationType)[0];
      this.store.commit(`notificationStore/${AddToastNotification}`, {
        type: event.notificationType,
        title: `${event.notification.name} - Document translation status - ${status}`,
        notification: event.notification,
        createdAt: event.createdAt,
      });
    }

    return event.notification.externalId;
  }

  /**
   * Show a bell notification.
   */
  bell(event) {
    const notificationType = this.notifications.find(
      ({ notificationType }) => notificationType === event.notificationType,
    );

    if (event.toast) {
      this.addToast(event);
    }

    if (notificationType) {
      this.store.commit(
        `notificationStore/${AddNotification}`,
        notificationType.transform(event.notificationId, event.notification, event.createdAt, event.readAt),
      );
    }
  }

  markAllAsRead() {
    console.log(this.ctx);
  }
}
